import { render, staticRenderFns } from "./spread-center.vue?vue&type=template&id=1552c216&"
import script from "./spread-center.vue?vue&type=script&lang=js&"
export * from "./spread-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports